import $axios from "@/api";

const state = () => ({
    data_close : {
        checkeds : [],
        remark : '',
        form : false,
    },
})

const mutations = {
   
}

const actions = {
    
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
